/* rebuild-vid-lazy.js — site-wide lazy loader for PDP product videos.
   Markup: <div data-lazyvid><video preload="none" poster=...>
             <source data-lazysrc="..." type="video/mp4"></video></div>
   Loads the real source only when the card scrolls into view → 0 video bytes
   at first paint (PageSpeed/LCP win). Full quality preserved (highest-res mp4).
   Linked in layout/theme.liquid (NOT inside a section — section scripts get
   stripped by the theme lazyload optimizer). No tracking touched. */
(function () {
  function load(card) {
    if (card.getAttribute('data-lv')) return;
    var v = card.querySelector('video');
    if (!v) return;
    var s = v.querySelector('source[data-lazysrc]');
    var desk = window.matchMedia && window.matchMedia('(min-width:768px)').matches;
    if (s && !s.getAttribute('src')) {
      // 2026-10-12 owner: on desktop show the video's own first frame, not the cover picture (some covers are size cards)
      if (desk) { v.removeAttribute('poster'); v.setAttribute('preload', 'metadata'); }
      s.setAttribute('src', s.getAttribute('data-lazysrc') + (desk ? '#t=0.1' : ''));
      v.load();
    }
    card.setAttribute('data-lv', '1');
    // 2026-10-12 owner: no autoplay on desktop; the customer clicks play (controls stay on)
    if (desk) return;
    // autoplay muted on view on phones (consistent with site); ignore promise rejection
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function init() {
    var cards = document.querySelectorAll('[data-lazyvid]');
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) {
      [].forEach.call(cards, load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          load(e.target);
        } else {
          var v = e.target.querySelector('video');
          if (v && !v.paused) { try { v.pause(); } catch (x) {} }
        }
      });
    }, { threshold: 0.25, rootMargin: '200px' });
    [].forEach.call(cards, function (c) { io.observe(c); });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
